import { Component, OnInit, ViewChild, ElementRef, HostListener, VERSION } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ReceiveAdviceComponent } from './../component/receive-advice/receive-advice.component';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Title, Meta   } from '@angular/platform-browser';
import { Platform } from '@ionic/angular';

@Component({
	selector: 'app-home1',
	templateUrl: './home1.component.html',
	styleUrls: ['./home1.component.scss']
})
export class Home1Component implements OnInit {
	@ViewChild("achieve", { static: true }) achieve: ElementRef;
	isMobile: any
	checkAchieve = false;
	title = 'Viethas LTD - Cung cấp giải pháp công nghệ và các ứng dụng quản lý';
	constructor(
		public dialog: MatDialog,
		private titleService: Title,
		private metaTagService: Meta,
		public platform: Platform
	) {
		if (platform.width() < 768) this.isMobile = true
    else if (platform.is("android") || platform.is("ios")) this.isMobile = false
    else this.isMobile = false
	}

	ngOnInit() {
		AOS.init()
		this.titleService.setTitle(this.title);
		this.metaTagService.addTags([
			{ name: 'description', content: 'Viethas cung cấp cho khách hàng những sản phẩm về phần mềm (phần mềm bán hàng, phần mềm quản lý hàng hóa, quản lý cà phê - nhà hàng, phần mềm quản lý thu chi,…); các giải pháp công nghệ IoT (hệ thống giám sát năng lượng, giải pháp nông nghiệp thông minh..)' },
			{ name: 'keywords', content: 'phần mềm order cho quán cafe, nhà hàng miễn phí, ứng dụng quản lý bán hàng miễn phí, cloud camera, dịch vụ cloud cho cammera , bảo vệ camera giám sát, ứng dụng nhà thông minh ' },
			{ name: 'robots', content: 'index, follow' },
			{ name: 'revisit - after', content: '1 days' },
			{ name: 'content - language', content: 'vi' },
			{ name: 'author', content: 'Viethas LTD' },
			{ name: 'viewport', content: 'width=device-width, initial-scale=1' },
			{ name: 'google', content: 'nositelinkssearchbox' },
			{ charset: 'text/html; charset=utf-8' }
		]);
		this.googleSEO_sales_viethas_app();
		this.googleSEO_cafe_viethas_app();
	}

	//Contact
	contactClick(event) {
		if (event.status) {
			this.openDialog_contact();
		}
	}


	openDialog_contact(): void {
		const dialog_contact = this.dialog.open(ReceiveAdviceComponent, {
			width: '60%'
		});

		dialog_contact.afterClosed().subscribe(result => {
			console.log('The dialog was closed');
		});
	}
	//HostListener

	@HostListener("window:scroll", ['$event'])
	public onScroll(): void {
		let sAch = this.achieve.nativeElement.getBoundingClientRect().top
		if (sAch <= 250 && sAch >= -150) {
			this.checkAchieve = true
		}

	};

	public googleSEO_sales_viethas_app() {
		this.metaTagService.addTags([
			{ name: 'keywords', content: 'phan mem ban hang' },
			{ name: 'keywords', content: 'phần mềm bán hàng' },
			{ name: 'keywords', content: 'phan mem ban hang mien phi' },
			{ name: 'keywords', content: 'phần mềm bán hàng miễn phí' },
			{ name: 'keywords', content: 'phan mem ban hang hoan toan mien phi' },
			{ name: 'keywords', content: 'phần mềm bán hàng hoàn toàn miễn phí' },
			{ name: 'keywords', content: 'phan mem ban hang gia re' },
			{ name: 'keywords', content: 'phần mềm bán hàng giá rẻ' },
			{ name: 'keywords', content: 'phan mem ban hang nhieu tinh nang gia re' },
			{ name: 'keywords', content: 'phần mềm bán hàng nhiều tính năng giá rẻ' },
			{ name: 'keywords', content: 'phan mem ban hang online' },
			{ name: 'keywords', content: 'phần mềm bán hàng online' },
			{ name: 'keywords', content: 'phan mem ban hang online mien phi' },
			{ name: 'keywords', content: 'phần mềm bán hàng online miễn phí' },
			{ name: 'keywords', content: 'phan mem ban hang online hoan toan mien phi' },
			{ name: 'keywords', content: 'phần mềm bán hàng online hoàn toàn miễn phí' },
			{ name: 'keywords', content: 'phan mem ban hang da kenh' },
			{ name: 'keywords', content: 'phần mềm bán hàng đa kênh' },
			{ name: 'keywords', content: 'phan mem ban hang da kenh mien phi' },
			{ name: 'keywords', content: 'phần mềm bán hàng đa kênh miễn phí' },
			{ name: 'keywords', content: 'phan mem ban hang da kenh hoan toan mien phi' },
			{ name: 'keywords', content: 'phần mềm bán hàng đa kênh hoàn toàn miễn phí' },
			{ name: 'keywords', content: 'phan mem ban hang online da kenh' },
			{ name: 'keywords', content: 'phần mềm bán hàng online đa kênh' },
			{ name: 'keywords', content: 'phan mem ban hang online da kenh mien phi' },
			{ name: 'keywords', content: 'phần mềm bán hàng online đa kênh miễn phí' },
			{ name: 'keywords', content: 'phan mem ban hang online da kenh hoan toan mien phi' },
			{ name: 'keywords', content: 'phần mềm bán hàng online đa kênh hoàn toàn miễn phí' },
			{ name: 'keywords', content: 'phan mem ban hang thuong mai dien tu' },
			{ name: 'keywords', content: 'phần mềm bán hàng thương mại điện tử' },
			{ name: 'keywords', content: 'phan mem ban hang thuong mai dien tu mien phi' },
			{ name: 'keywords', content: 'phần mềm bán hàng thương mại điện tử miễn phí' },
			{ name: 'keywords', content: 'phan mem ban hang thuong mai dien tu hoan toan mien phi' },
			{ name: 'keywords', content: 'phần mềm bán hàng thương mại điện tử hoàn toàn miễn phí' },
			{ name: 'keywords', content: 'phan mem ban hang tren dien thoai' },
			{ name: 'keywords', content: 'phần mềm bán hàng trên điện thoại' },
			{ name: 'keywords', content: 'phan mem ban hang tren dien thoai mien phi' },
			{ name: 'keywords', content: 'phần mềm bán hàng trên điện thoại miễn phí' },
			{ name: 'keywords', content: 'phan mem ban hang tren dien thoai hoan toan mien phi' },
			{ name: 'keywords', content: 'phần mềm bán hàng trên điện thoại hoàn toàn miễn phí' },
			{ name: 'keywords', content: 'phan mem ban hang tap hoa' },
			{ name: 'keywords', content: 'phần mềm bán hàng tạp hóa' },
			{ name: 'keywords', content: 'phan mem ban hang tap hoa mien phi' },
			{ name: 'keywords', content: 'phần mềm bán hàng tạp hóa miễn phí' },
			{ name: 'keywords', content: 'phan mem ban hang tap hoa hoan toan mien phi' },
			{ name: 'keywords', content: 'phần mềm bán hàng tạp hóa hoàn toàn miễn phí' },
			{ name: 'keywords', content: 'phan mem ban hang sieu thi' },
			{ name: 'keywords', content: 'phần mềm bán hàng siêu thị' },
			{ name: 'keywords', content: 'phan mem ban hang sieu thi tap hoa mien phi' },
			{ name: 'keywords', content: 'phần mềm bán hàng siêu thị tạp hóa miễn phí' },
			{ name: 'keywords', content: 'phan mem ban hang sieu thi tap hoa hoan toan mien phi' },
			{ name: 'keywords', content: 'phần mềm bán hàng siêu thị tạp hóa hoàn toàn miễn phí' },
			{ name: 'keywords', content: 'phan mem ban le' },
			{ name: 'keywords', content: 'phần mềm bán lẻ' },
			{ name: 'keywords', content: 'phan mem ban le mien phi' },
			{ name: 'keywords', content: 'phần mềm bán lẻ miễn phí' },
			{ name: 'keywords', content: 'phan mem ban le hoan toan mien phi' },
			{ name: 'keywords', content: 'phần mềm bán lẻ hoàn toàn miễn phí' },
			{ name: 'keywords', content: 'phan mem ban si' },
			{ name: 'keywords', content: 'phần mềm bán sỉ' },
			{ name: 'keywords', content: 'phan mem ban si mien phi' },
			{ name: 'keywords', content: 'phần mềm bán sỉ miễn phí' },
			{ name: 'keywords', content: 'phan mem ban si hoan toan mien phi' },
			{ name: 'keywords', content: 'phần mềm bán sỉ hoàn toàn miễn phí' },
			{ name: 'keywords', content: 'phan mem ban hang chuoi' },
			{ name: 'keywords', content: 'phần mềm bán hàng chuỗi' },
			{ name: 'keywords', content: 'phan mem ban hang chuoi mien phi' },
			{ name: 'keywords', content: 'phần mềm bán hàng chuỗi miễn phí' },
			{ name: 'keywords', content: 'phan mem ban hang chuoi hoan toan mien phi' },
			{ name: 'keywords', content: 'phần mềm bán hàng chuỗi hoàn toàn miễn phí' },
			{ name: 'keywords', content: 'phan mem ban hang chi nhanh' },
			{ name: 'keywords', content: 'phần mềm bán hàng chi nhánh' },
			{ name: 'keywords', content: 'phan mem ban hang chi nhanh mien phi' },
			{ name: 'keywords', content: 'phần mềm bán hàng chi nhánh miễn phí' },
			{ name: 'keywords', content: 'phan mem ban hang chi nhanh hoan toan mien phi' },
			{ name: 'keywords', content: 'phần mềm bán hàng chi nhánh hoàn toàn miễn phí' },
			{ name: 'keywords', content: 'phan mem ban hang nhieu chi nhanh' },
			{ name: 'keywords', content: 'phần mềm bán hàng nhiều chi nhánh' },
			{ name: 'keywords', content: 'phan mem ban hang nhieu chi nhanh mien phi' },
			{ name: 'keywords', content: 'phần mềm bán hàng nhiều chi nhánh miễn phí' },
			{ name: 'keywords', content: 'phan mem ban hang nhieu chi nhanh hoan toan mien phi' },
			{ name: 'keywords', content: 'phần mềm bán hàng nhiều chi nhánh hoàn toàn miễn phí' },
			{ name: 'keywords', content: 'phan mem ban hang cua hang tien loi' },
			{ name: 'keywords', content: 'phần mềm bán hàng cửa hàng tiện lợi' },
			{ name: 'keywords', content: 'phan mem ban hang cua hang tien loi mien phi' },
			{ name: 'keywords', content: 'phần mềm bán hàng cửa hàng tiện lợi miễn phí' },
			{ name: 'keywords', content: 'phan mem ban hang cua hang tien loi hoan toan mien phi' },
			{ name: 'keywords', content: 'phần mềm bán hàng cửa hàng tiện lợi hoàn toàn miễn phí' },
			{ name: 'keywords', content: 'phan mem ban hang dien thoai' },
			{ name: 'keywords', content: 'phần mềm bán hàng điện thoại' },
			{ name: 'keywords', content: 'phan mem ban hang dien thoai mien phi' },
			{ name: 'keywords', content: 'phần mềm bán hàng điện thoại miễn phí' },
			{ name: 'keywords', content: 'phan mem ban hang dien thoai hoan toan mien phi' },
			{ name: 'keywords', content: 'phần mềm bán hàng điện thoại hoàn toàn miễn phí' },
			{ name: 'keywords', content: 'phan mem ban hang cua hang dien thoai' },
			{ name: 'keywords', content: 'phần mềm bán hàng cửa hàng điện thoại' },
			{ name: 'keywords', content: 'phan mem ban hang cua hang dien thoai mien phi' },
			{ name: 'keywords', content: 'phần mềm bán hàng cửa hàng điện thoại miễn phí' },
			{ name: 'keywords', content: 'phan mem ban hang cua hang dien thoai hoan toan mien phi' },
			{ name: 'keywords', content: 'phần mềm bán hàng cửa hàng điện thoại hoàn toàn miễn phí' },
			{ name: 'keywords', content: 'phan mem ban hang cua hang' },
			{ name: 'keywords', content: 'phần mềm bán hàng cửa hàng' },
			{ name: 'keywords', content: 'phan mem ban hang cua hang mien phi' },
			{ name: 'keywords', content: 'phần mềm bán hàng cửa hàng miễn phí' },
			{ name: 'keywords', content: 'phan mem ban hang cua hang hoan toan mien phi' },
			{ name: 'keywords', content: 'phần mềm bán hàng cửa hàng hoàn toàn miễn phí' },
			{ name: 'keywords', content: 'phan mem ban hang cong ty' },
			{ name: 'keywords', content: 'phần mềm bán hàng công ty' },
			{ name: 'keywords', content: 'phan mem ban hang cong ty mien phi' },
			{ name: 'keywords', content: 'phần mềm bán hàng công ty miễn phí' },
			{ name: 'keywords', content: 'phan mem ban hang cong ty hoan toan mien phi' },
			{ name: 'keywords', content: 'phần mềm bán hàng công ty hoàn toàn miễn phí' },
			{ name: 'keywords', content: 'phan mem ban hang doanh nghiep' },
			{ name: 'keywords', content: 'phần mềm bán hàng doanh nghiệp' },
			{ name: 'keywords', content: 'phan mem ban hang doanh nghiep mien phi' },
			{ name: 'keywords', content: 'phần mềm bán hàng doanh nghiệp miễn phí' },
			{ name: 'keywords', content: 'phan mem ban hang doanh nghiep hoan toan mien phi' },
			{ name: 'keywords', content: 'phần mềm bán hàng doanh nghiệp hoàn toàn miễn phí' },
			{ name: 'keywords', content: 'phan mem ban hang doanh nghiep hoan toan mien phi vua va nho' },
			{ name: 'keywords', content: 'phần mềm bán hàng doanh nghiệp vừa và nhỏ' },
			{ name: 'keywords', content: 'phan mem ban hang doanh nghiep hoan toan mien phi mien phi' },
			{ name: 'keywords', content: 'phần mềm bán hàng doanh nghiệp vừa và nhỏ miễn phí' },
			{ name: 'keywords', content: 'phan mem ban hang doanh nghiep hoan toan mien phi hoan toan mien phi' },
			{ name: 'keywords', content: 'phần mềm bán hàng doanh nghiệp vừa và nhỏ hoàn toàn miễn phí' },
			{ name: 'keywords', content: 'phan mem ban hang so mot' },
			{ name: 'keywords', content: 'phần mềm bán hàng số một' },
			{ name: 'keywords', content: 'phan mem ban hang so mot mien phi' },
			{ name: 'keywords', content: 'phần mềm bán hàng số một miễn phí' },
			{ name: 'keywords', content: 'phan mem ban hang so mot hoan toan mien phi' },
			{ name: 'keywords', content: 'phần mềm bán hàng số một hoàn toàn miễn phí' },
			{ name: 'keywords', content: 'phan mem ban hang so mot viet nam' },
			{ name: 'keywords', content: 'phần mềm bán hàng số một việt nam' },
			{ name: 'keywords', content: 'phan mem ban hang so mot viet nam mien phi' },
			{ name: 'keywords', content: 'phần mềm bán hàng số một việt nam miễn phí' },
			{ name: 'keywords', content: 'phan mem ban hang so mot viet nam hoan toan mien phi' },
			{ name: 'keywords', content: 'phần mềm bán hàng số một việt nam hoàn toàn miễn phí' },
			{ name: 'keywords', content: 'phan mem ban hang top 1' },
			{ name: 'keywords', content: 'phần mềm bán hàng top 1' },
			{ name: 'keywords', content: 'phan mem ban hang top 1 mien phi' },
			{ name: 'keywords', content: 'phần mềm bán hàng top 1 miễn phí' },
			{ name: 'keywords', content: 'phan mem ban hang top 1 hoan toan mien phi' },
			{ name: 'keywords', content: 'phần mềm bán hàng top 1 hoàn toàn miễn phí' },
			{ name: 'keywords', content: 'phan mem ban hang top 10' },
			{ name: 'keywords', content: 'phần mềm bán hàng top 10' },
			{ name: 'keywords', content: 'phan mem ban hang top 10 mien phi' },
			{ name: 'keywords', content: 'phần mềm bán hàng top 10 miễn phí' },
			{ name: 'keywords', content: 'phan mem ban hang top 10 hoan toan mien phi' },
			{ name: 'keywords', content: 'phần mềm bán hàng top 10 hoàn toàn miễn phí' },
			{ name: 'keywords', content: 'phan mem ban hang top 1 viet nam' },
			{ name: 'keywords', content: 'phần mềm bán hàng top 1 việt nam' },
			{ name: 'keywords', content: 'phan mem ban hang top 1 viet nam mien phi' },
			{ name: 'keywords', content: 'phần mềm bán hàng top 1 việt nam miễn phí' },
			{ name: 'keywords', content: 'phan mem ban hang top 1 viet nam hoan toan mien phi' },
			{ name: 'keywords', content: 'phần mềm bán hàng top 1 việt nam hoàn toàn miễn phí' },
			{ name: 'keywords', content: 'phan mem ban hang top 10 viet nam' },
			{ name: 'keywords', content: 'phần mềm bán hàng top 10 việt nam' },
			{ name: 'keywords', content: 'phan mem ban hang top 10 viet nam mien phi' },
			{ name: 'keywords', content: 'phần mềm bán hàng top 10 việt nam miễn phí' },
			{ name: 'keywords', content: 'phan mem ban hang top 10 viet nam hoan toan mien phi' },
			{ name: 'keywords', content: 'phần mềm bán hàng top 10 việt nam hoàn toàn miễn phí' },

			{ name: 'keywords', content: 'phan mem quan ly ban hang' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang mien phi' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng miễn phí' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang hoan toan mien phi' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng hoàn toàn miễn phí' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang gia re' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng giá rẻ' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang nhieu tinh nang gia re' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng nhiều tính năng giá rẻ' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang online' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng online' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang online mien phi' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng online miễn phí' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang online hoan toan mien phi' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng online hoàn toàn miễn phí' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang da kenh' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng đa kênh' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang da kenh mien phi' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng đa kênh miễn phí' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang da kenh hoan toan mien phi' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng đa kênh hoàn toàn miễn phí' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang online da kenh' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng online đa kênh' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang online da kenh mien phi' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng online đa kênh miễn phí' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang online da kenh hoan toan mien phi' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng online đa kênh hoàn toàn miễn phí' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang thuong mai dien tu' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng thương mại điện tử' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang thuong mai dien tu mien phi' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng thương mại điện tử miễn phí' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang thuong mai dien tu hoan toan mien phi' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng thương mại điện tử hoàn toàn miễn phí' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang tren dien thoai' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng trên điện thoại' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang tren dien thoai mien phi' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng trên điện thoại miễn phí' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang tren dien thoai hoan toan mien phi' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng trên điện thoại hoàn toàn miễn phí' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang tap hoa' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng tạp hóa' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang tap hoa mien phi' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng tạp hóa miễn phí' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang tap hoa hoan toan mien phi' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng tạp hóa hoàn toàn miễn phí' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang sieu thi' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng siêu thị' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang sieu thi tap hoa mien phi' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng siêu thị tạp hóa miễn phí' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang sieu thi tap hoa hoan toan mien phi' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng siêu thị tạp hóa hoàn toàn miễn phí' },
			{ name: 'keywords', content: 'phan mem quan ly ban le' },
			{ name: 'keywords', content: 'phần mềm quản lý bán lẻ' },
			{ name: 'keywords', content: 'phan mem quan ly ban le mien phi' },
			{ name: 'keywords', content: 'phần mềm quản lý bán lẻ miễn phí' },
			{ name: 'keywords', content: 'phan mem quan ly ban le hoan toan mien phi' },
			{ name: 'keywords', content: 'phần mềm quản lý bán lẻ hoàn toàn miễn phí' },
			{ name: 'keywords', content: 'phan mem quan ly ban si' },
			{ name: 'keywords', content: 'phần mềm quản lý bán sỉ' },
			{ name: 'keywords', content: 'phan mem quan ly ban si mien phi' },
			{ name: 'keywords', content: 'phần mềm quản lý bán sỉ miễn phí' },
			{ name: 'keywords', content: 'phan mem quan ly ban si hoan toan mien phi' },
			{ name: 'keywords', content: 'phần mềm quản lý bán sỉ hoàn toàn miễn phí' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang chuoi' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng chuỗi' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang chuoi mien phi' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng chuỗi miễn phí' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang chuoi hoan toan mien phi' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng chuỗi hoàn toàn miễn phí' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang chi nhanh' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng chi nhánh' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang chi nhanh mien phi' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng chi nhánh miễn phí' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang chi nhanh hoan toan mien phi' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng chi nhánh hoàn toàn miễn phí' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang nhieu chi nhanh' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng nhiều chi nhánh' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang nhieu chi nhanh mien phi' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng nhiều chi nhánh miễn phí' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang nhieu chi nhanh hoan toan mien phi' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng nhiều chi nhánh hoàn toàn miễn phí' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang cua hang tien loi' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng cửa hàng tiện lợi' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang cua hang tien loi mien phi' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng cửa hàng tiện lợi miễn phí' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang cua hang tien loi hoan toan mien phi' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng cửa hàng tiện lợi hoàn toàn miễn phí' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang dien thoai' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng điện thoại' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang dien thoai mien phi' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng điện thoại miễn phí' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang dien thoai hoan toan mien phi' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng điện thoại hoàn toàn miễn phí' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang cua hang dien thoai' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng cửa hàng điện thoại' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang cua hang dien thoai mien phi' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng cửa hàng điện thoại miễn phí' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang cua hang dien thoai hoan toan mien phi' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng cửa hàng điện thoại hoàn toàn miễn phí' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang cua hang' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng cửa hàng' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang cua hang mien phi' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng cửa hàng miễn phí' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang cua hang hoan toan mien phi' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng cửa hàng hoàn toàn miễn phí' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang cong ty' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng công ty' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang cong ty mien phi' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng công ty miễn phí' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang cong ty hoan toan mien phi' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng công ty hoàn toàn miễn phí' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang doanh nghiep' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng doanh nghiệp' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang doanh nghiep mien phi' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng doanh nghiệp miễn phí' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang doanh nghiep hoan toan mien phi' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng doanh nghiệp hoàn toàn miễn phí' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang doanh nghiep hoan toan mien phi vua va nho' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng doanh nghiệp vừa và nhỏ' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang doanh nghiep hoan toan mien phi mien phi' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng doanh nghiệp vừa và nhỏ miễn phí' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang doanh nghiep hoan toan mien phi hoan toan mien phi' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng doanh nghiệp vừa và nhỏ hoàn toàn miễn phí' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang so mot' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng số một' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang so mot mien phi' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng số một miễn phí' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang so mot hoan toan mien phi' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng số một hoàn toàn miễn phí' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang so mot viet nam' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng số một việt nam' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang so mot viet nam mien phi' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng số một việt nam miễn phí' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang so mot viet nam hoan toan mien phi' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng số một việt nam hoàn toàn miễn phí' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang top 1' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng top 1' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang top 1 mien phi' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng top 1 miễn phí' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang top 1 hoan toan mien phi' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng top 1 hoàn toàn miễn phí' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang top 10' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng top 10' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang top 10 mien phi' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng top 10 miễn phí' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang top 10 hoan toan mien phi' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng top 10 hoàn toàn miễn phí' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang top 1 viet nam' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng top 1 việt nam' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang top 1 viet nam mien phi' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng top 1 việt nam miễn phí' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang top 1 viet nam hoan toan mien phi' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng top 1 việt nam hoàn toàn miễn phí' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang top 10 viet nam' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng top 10 việt nam' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang top 10 viet nam mien phi' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng top 10 việt nam miễn phí' },
			{ name: 'keywords', content: 'phan mem quan ly ban hang top 10 viet nam hoan toan mien phi' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng top 10 việt nam hoàn toàn miễn phí' },
			{ name: 'keywords', content: 'ButterCMS Viethas' },
			{ name: 'keywords', content: 'Home page of SEO friendly app Viethas' },
			{ name: 'keywords', content: 'phần mềm sales viethas' },

		]);
	}

	public googleSEO_cafe_viethas_app() {
		this.metaTagService.addTags([
			{ name: 'keywords', content: 'phan mem nha hang' },
			{ name: 'keywords', content: 'phần mềm nhà hàng' },
			{ name: 'keywords', content: 'phan mem nha hang mien phi' },
			{ name: 'keywords', content: 'phần mềm nhà hàng miễn phí' },
			{ name: 'keywords', content: 'phan mem nha hang an uong' },
			{ name: 'keywords', content: 'phần mềm nhà hàng ăn uống' },
			{ name: 'keywords', content: 'phan mem nha hang an uong mien phi' },
			{ name: 'keywords', content: 'phần mềm nhà hàng ăn uống miễn phí' },
			{ name: 'keywords', content: 'phan mem nha hang quan an' },
			{ name: 'keywords', content: 'phần mềm nhà hàng quán ăn' },
			{ name: 'keywords', content: 'phan mem nha hang quan an mien phi' },
			{ name: 'keywords', content: 'phần mềm nhà hàng quán ăn miễn phí' },
			{ name: 'keywords', content: 'phan mem nha hang cafe' },
			{ name: 'keywords', content: 'phần mềm nhà hàng cafe' },
			{ name: 'keywords', content: 'phan mem nha hang cafe mien phi' },
			{ name: 'keywords', content: 'phần mềm nhà hàng cafe miễn phí' },
			{ name: 'keywords', content: 'phan mem quan an' },
			{ name: 'keywords', content: 'phần mềm quán ăn' },
			{ name: 'keywords', content: 'phan mem quan an mien phi' },
			{ name: 'keywords', content: 'phần mềm quán ăn miễn phí' },
			{ name: 'keywords', content: 'phan mem chuoi nha hang' },
			{ name: 'keywords', content: 'phần mềm chuỗi nhà hàng' },
			{ name: 'keywords', content: 'phan mem chuoi nha hang mien phi' },
			{ name: 'keywords', content: 'phần mềm chuỗi nhà hàng miễn phí' },
			{ name: 'keywords', content: 'phan mem chuoi cafe' },
			{ name: 'keywords', content: 'phần mềm chuỗi cafe' },
			{ name: 'keywords', content: 'phan mem chuoi cafe mien phi' },
			{ name: 'keywords', content: 'phần mềm chuỗi cafe miễn phí' },
			{ name: 'keywords', content: 'phan mem quan tra sua' },
			{ name: 'keywords', content: 'phần mềm quán trà sửa' },
			{ name: 'keywords', content: 'phần mềm quan tra sua mien phi' },
			{ name: 'keywords', content: 'phần mềm quán trà sửa miễn phí' },
			{ name: 'keywords', content: 'phan mem quan ly nha hang' },
			{ name: 'keywords', content: 'phần mềm quản lý nhà hàng' },
			{ name: 'keywords', content: 'phan mem quan ly nha hang mien phi' },
			{ name: 'keywords', content: 'phần mềm quản lý nhà hàng miễn phí' },
			{ name: 'keywords', content: 'phan mem quan ly quan an' },
			{ name: 'keywords', content: 'phần mềm quản lý quán ăn' },
			{ name: 'keywords', content: 'phan mem quan ly quan an mien phi' },
			{ name: 'keywords', content: 'phần mềm quản lý quán ăn miễn phí' },
			{ name: 'keywords', content: 'phan mem quan ly an uong nha hang' },
			{ name: 'keywords', content: 'phần mềm quản lý ăn uống nhà hàng' },
			{ name: 'keywords', content: 'phan mem quan ly an uong nha hang mien phi' },
			{ name: 'keywords', content: 'phần mềm quản lý ăn uống nhà hàng miễn phí' },
			{ name: 'keywords', content: 'phan mem quan ly kho nha hang' },
			{ name: 'keywords', content: 'phần mềm quản lý kho nhà hàng' },
			{ name: 'keywords', content: 'phan mem quan ly kho nha hang mien phi' },
			{ name: 'keywords', content: 'phần mềm quản lý kho nhà hàng miễn phí' },
			{ name: 'keywords', content: 'phan mem quan ly nha hang cafe' },
			{ name: 'keywords', content: 'phần mềm quản lý nhà hàng cafe' },
			{ name: 'keywords', content: 'phan mem quan ly nha hang mien phi cafe' },
			{ name: 'keywords', content: 'phần mềm quản lý nhà hàng miễn phí cafe' },
			{ name: 'keywords', content: 'phan mem quan ly quan an nha hang' },
			{ name: 'keywords', content: 'phần mềm quản lý quán ăn nhà hàng' },
			{ name: 'keywords', content: 'phan mem quan ly quan an nha hang mien phi' },
			{ name: 'keywords', content: 'phần mềm quản lý quán ăn nhà hàng miễn phí' },
			{ name: 'keywords', content: 'phan mem quan ly chuoi nha hang' },
			{ name: 'keywords', content: 'phần mềm quản lý chuỗi nhà hàng' },
			{ name: 'keywords', content: 'phan mem quan ly chuoi nha hang mien phi' },
			{ name: 'keywords', content: 'phần mềm quản lý chuỗi nhà hàng miễn phí' },
			{ name: 'keywords', content: 'phan mem quan ly chuoi cafe' },
			{ name: 'keywords', content: 'phần mềm quản lý chuỗi cafe' },
			{ name: 'keywords', content: 'phan mem quan ly chuoi cafe mien phi' },
			{ name: 'keywords', content: 'phần mềm quản lý chuỗi cafe miễn phí' },
			{ name: 'keywords', content: 'phan mem quan ly quan tra sua' },
			{ name: 'keywords', content: 'phần mềm quản lý quán trà sửa' },
			{ name: 'keywords', content: 'phần mềm quan ly quan tra sua mien phi' },
			{ name: 'keywords', content: 'phần mềm quản lý quán trà sửa miễn phí' },
			{ name: 'keywords', content: 'phan mem may POS nha hang' },
			{ name: 'keywords', content: 'phần mềm máy POS nhà hàng' },
			{ name: 'keywords', content: 'phan mem may POS nha hang mien phi' },
			{ name: 'keywords', content: 'phần mềm máy POS nhà hàng miễn phí' },
			{ name: 'keywords', content: 'phan mem may POS cafe' },
			{ name: 'keywords', content: 'phần mềm máy POS cafe' },
			{ name: 'keywords', content: 'phan mem may POS cafe mien phi' },
			{ name: 'keywords', content: 'phần mềm máy POS cafe miễn phí' },
			{ name: 'keywords', content: 'phan mem may POS quán cafe' },
			{ name: 'keywords', content: 'phần mềm máy POS quán cafe' },
			{ name: 'keywords', content: 'phan mem may POS quán cafe mien phi' },
			{ name: 'keywords', content: 'phần mềm máy POS quán cafe miễn phí' },
			{ name: 'keywords', content: 'phần mềm quản lý nhà hàng nào tốt' },
			{ name: 'keywords', content: 'phần mềm quản lý nhà hàng tốt' },
			{ name: 'keywords', content: 'phần mềm quản lý nhà hàng cà phê' },
			{ name: 'keywords', content: 'phần mềm quản lý thu chi nhà hàng' },
			{ name: 'keywords', content: 'phần mềm quản lý nhà hàng pos' },
			{ name: 'keywords', content: 'phần mềm quản lý bán hàng nhà hàng' },
			{ name: 'keywords', content: 'phần mềm quản lý nhà hàng cafe' },
			{ name: 'keywords', content: 'phần mềm quản lý nhà hàng quán ăn' },
			{ name: 'keywords', content: 'phần mềm quản lý cho nhà hàng' },
			{ name: 'keywords', content: 'giá phần mềm quản lý nhà hàng' },
			{ name: 'keywords', content: 'ứng dụng quản lý nhà hàng' },
			{ name: 'keywords', content: 'phần mềm quán ăn' },
			{ name: 'keywords', content: 'phần mềm pos cho nhà hàng' },
			{ name: 'keywords', content: 'phần mềm nhà hàng miễn phí' }
		]);
	}

	keys: any = [
		{ name: 'keywords', content: 'phan mem ban hang' },
		{ name: 'keywords', content: 'phần mềm bán hàng' },
		{ name: 'keywords', content: 'phan mem ban hang mien phi' },
		{ name: 'keywords', content: 'phần mềm bán hàng miễn phí' },
		{ name: 'keywords', content: 'phan mem ban hang hoan toan mien phi' },
		{ name: 'keywords', content: 'phần mềm bán hàng hoàn toàn miễn phí' },
		{ name: 'keywords', content: 'phan mem ban hang gia re' },
		{ name: 'keywords', content: 'phần mềm bán hàng giá rẻ' },
		{ name: 'keywords', content: 'phan mem ban hang nhieu tinh nang gia re' },
		{ name: 'keywords', content: 'phần mềm bán hàng nhiều tính năng giá rẻ' },
		{ name: 'keywords', content: 'phan mem ban hang online' },
		{ name: 'keywords', content: 'phần mềm bán hàng online' },
		{ name: 'keywords', content: 'phan mem ban hang online mien phi' },
		{ name: 'keywords', content: 'phần mềm bán hàng online miễn phí' },
		{ name: 'keywords', content: 'phan mem ban hang online hoan toan mien phi' },
		{ name: 'keywords', content: 'phần mềm bán hàng online hoàn toàn miễn phí' },
		{ name: 'keywords', content: 'phan mem ban hang da kenh' },
		{ name: 'keywords', content: 'phần mềm bán hàng đa kênh' },
		{ name: 'keywords', content: 'phan mem ban hang da kenh mien phi' },
		{ name: 'keywords', content: 'phần mềm bán hàng đa kênh miễn phí' },
		{ name: 'keywords', content: 'phan mem ban hang da kenh hoan toan mien phi' },
		{ name: 'keywords', content: 'phần mềm bán hàng đa kênh hoàn toàn miễn phí' },
		{ name: 'keywords', content: 'phan mem ban hang online da kenh' },
		{ name: 'keywords', content: 'phần mềm bán hàng online đa kênh' },
		{ name: 'keywords', content: 'phan mem ban hang online da kenh mien phi' },
		{ name: 'keywords', content: 'phần mềm bán hàng online đa kênh miễn phí' },
		{ name: 'keywords', content: 'phan mem ban hang online da kenh hoan toan mien phi' },
		{ name: 'keywords', content: 'phần mềm bán hàng online đa kênh hoàn toàn miễn phí' },
		{ name: 'keywords', content: 'phan mem ban hang thuong mai dien tu' },
		{ name: 'keywords', content: 'phần mềm bán hàng thương mại điện tử' },
		{ name: 'keywords', content: 'phan mem ban hang thuong mai dien tu mien phi' },
		{ name: 'keywords', content: 'phần mềm bán hàng thương mại điện tử miễn phí' },
		{ name: 'keywords', content: 'phan mem ban hang thuong mai dien tu hoan toan mien phi' },
		{ name: 'keywords', content: 'phần mềm bán hàng thương mại điện tử hoàn toàn miễn phí' },
		{ name: 'keywords', content: 'phan mem ban hang tren dien thoai' },
		{ name: 'keywords', content: 'phần mềm bán hàng trên điện thoại' },
		{ name: 'keywords', content: 'phan mem ban hang tren dien thoai mien phi' },
		{ name: 'keywords', content: 'phần mềm bán hàng trên điện thoại miễn phí' },
		{ name: 'keywords', content: 'phan mem ban hang tren dien thoai hoan toan mien phi' },
		{ name: 'keywords', content: 'phần mềm bán hàng trên điện thoại hoàn toàn miễn phí' },
		{ name: 'keywords', content: 'phan mem ban hang tap hoa' },
		{ name: 'keywords', content: 'phần mềm bán hàng tạp hóa' },
		{ name: 'keywords', content: 'phan mem ban hang tap hoa mien phi' },
		{ name: 'keywords', content: 'phần mềm bán hàng tạp hóa miễn phí' },
		{ name: 'keywords', content: 'phan mem ban hang tap hoa hoan toan mien phi' },
		{ name: 'keywords', content: 'phần mềm bán hàng tạp hóa hoàn toàn miễn phí' },
		{ name: 'keywords', content: 'phan mem ban hang sieu thi' },
		{ name: 'keywords', content: 'phần mềm bán hàng siêu thị' },
		{ name: 'keywords', content: 'phan mem ban hang sieu thi tap hoa mien phi' },
		{ name: 'keywords', content: 'phần mềm bán hàng siêu thị tạp hóa miễn phí' },
		{ name: 'keywords', content: 'phan mem ban hang sieu thi tap hoa hoan toan mien phi' },
		{ name: 'keywords', content: 'phần mềm bán hàng siêu thị tạp hóa hoàn toàn miễn phí' },
		{ name: 'keywords', content: 'phan mem ban le' },
		{ name: 'keywords', content: 'phần mềm bán lẻ' },
	]
}
